import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FollowUpVisitModel } from '../models/FollowUpVisitModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class FollowUpVisitService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getFollowUpVisit(patientCode: string ,visserial: number, compcode: string) {

      let params = new HttpParams();
        params = params.append("PatientCode", patientCode);
        params = params.append("VisSerial", visserial);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<FollowUpVisitModel>(this.urlsconfig.WebAPIURL_Test + 'api/FollowUpVisit_D/GetFollowUpVisit',options);
    }

    public AddFollowUpVisit(SHistory: FollowUpVisitModel) {
      return this.http.post<FollowUpVisitModel>(this.urlsconfig.WebAPIURL_Test + 'api/FollowUpVisit_D/AddFollowUpVisit', SHistory);
    }

    public delFollowUpVisit(patientCode: string ,visserial :number, compcode: string) {

    let params = new HttpParams();
    params = params.append("PatientCode", patientCode);
    params = params.append("VisSerial", visserial);
    params = params.append("CompCode", compcode);
      const options = {
        params: params
    };
    return this.http.get<FollowUpVisitModel>(this.urlsconfig.WebAPIURL_Test + 'api/FollowUpVisit_D/DeleteFollowUpVisit_D',options);
    }
    public getFollowUpVisitLastSerial(patientCode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("PatientCode", patientCode);

        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<FollowUpVisitModel>(this.urlsconfig.WebAPIURL_Test + 'api/FollowUpVisit_D/GetFollowUpVisitLastSerial',options);
    }

  }
